var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.items,"label":_vm.label,"hint":_vm.hint,"readonly":_vm.readonly,"value":_vm.beanname,"rules":_vm.requiredRules},on:{"change":_vm.changeItem,"input":_vm.changeItem},scopedSlots:_vm._u([{key:"no-data",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('warnings.no_data_found'))+" ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }